export default __webpack_public_path__ + "media/images/favicon-9ef1891e.ico";